import { useQuery } from "@tanstack/react-query";
import {
  VacationPersonalParams,
  VacationPersonalService,
} from "../../../../../services/viags/vacation-personal.service";

export const VACATION_PERSONAL_QUERY_KEY = "vacation-personal";

export const useVacationPersonal = (params: VacationPersonalParams) => {
  return useQuery({
    queryKey: [VACATION_PERSONAL_QUERY_KEY, params.year, params.hrId],
    queryFn: () => VacationPersonalService.getPersonalVacation(params),
    enabled: !!params.hrId && !!params.year,
  });
};

